import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

const FullScreenImage = () => {
  const [imageData, setImageData] = useState(null);

  useEffect(() => {
    const handleOpen = (e) => setImageData(e.detail);
    const handleClose = () => setImageData(null);

    window.addEventListener('openFullScreenImage', handleOpen);
    window.addEventListener('closeFullScreenImage', handleClose);
    window.closeFullScreenImage = handleClose;

    return () => {
      window.removeEventListener('openFullScreenImage', handleOpen);
      window.removeEventListener('closeFullScreenImage', handleClose);
    };
  }, []);

  if (!imageData) return null;

  return createPortal(
    <div
      onClick={() => setImageData(null)}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.95)',
        zIndex: 99999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        animation: 'fadeIn 0.2s ease-out'
      }}
    >
      <button
        onClick={(e) => { e.stopPropagation(); setImageData(null); }}
        style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          background: 'rgba(255,255,255,0.2)',
          border: 'none',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
          color: 'white',
          zIndex: 100000
        }}
      >
        ✕
      </button>
      {imageData.userName && (
        <p style={{
          color: 'white',
          fontSize: '16px',
          marginBottom: '12px',
          fontWeight: 500,
          textShadow: '0 2px 4px rgba(0,0,0,0.5)'
        }}>
          {imageData.userName}
        </p>
      )}
      <img
        src={imageData.imageUrl}
        alt={imageData.userName || 'Full screen'}
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '90vw',
          maxHeight: '80vh',
          objectFit: 'contain',
          borderRadius: '8px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
          cursor: 'default'
        }}
      />
    </div>,
    document.body
  );
};

export default FullScreenImage;